import { render, staticRenderFns } from "./InboxView.vue?vue&type=template&id=5163eb9a&"
import script from "./InboxView.vue?vue&type=script&lang=js&"
export * from "./InboxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports